import { baseApi } from "../redux/baseAPI";

export const chatApi = baseApi.injectEndpoints({
  tagTypes: ["PatientChats", "LocationChatMessages", "RecentChats", "providerLocationChats", "ProblemMeta", "PatientInfo", "PaDocumate", "PracticeLocation",
    "NursingHomeLocation", "TaggedProvider", "TaggedNurse", "ProblemQuestions", "UnreadMessageCount"],
  endpoints: (builder) => ({
    getPatientChats: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_chats/get_patient_chat.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: (result, error, arg) =>
        result ? [...result.data.map(({ pid }) => ({ type: 'PatientChats', id: pid })), 'PatientChats'] : ['PatientChats']
    }),
    getLocationChatMessages: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_chats/get_location_chat_messages.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      providesTags: ["LocationChatMessages"],
    }),
    getRecentChats: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_chats/get_recent_chats.json`,
          method: "GET",
          params: { ...data },
        };
      },
      serializeQueryArgs: ({ queryArgs }) => {
        // Keep a single cache key for pagination
        return 'getRecentChats';
      },
      merge: (currentCache, newItems) => {
        // Merge new items with the current cache
        if(newItems.meta.page == 1){
          currentCache.data = newItems.data;
        }
        else{
          currentCache.data.push(...newItems.data);
        }

        currentCache.meta = {
          ...currentCache.meta,
          ...newItems.meta
        };
      },
      forceRefetch: ({ currentArg, previousArg }) => {
        // Refetch on page change
        return currentArg.page !== previousArg.page;
      },
      invalidatesTags: ["UnreadMessageCount"],
      transformResponse: (response, meta, arg) => response.response,
      providesTags: ["RecentChats"],
    }),
    getLocationChats: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_chats/get_location_chats.json`,
          method: "GET",
          params: { ...data },
        };
      },
      serializeQueryArgs: ({ queryArgs }) => {
        // Keep a single cache key for pagination
        return 'getLocationChats';
      },
      merge: (currentCache, newItems) => {
        // Merge new items with the current cache
        if(newItems.meta.page == 1){
          currentCache.data = newItems.data;
        }
        else{
          currentCache.data.push(...newItems.data);
        }

        currentCache.meta = {
          ...currentCache.meta,
          ...newItems.meta
        };
      },
      forceRefetch: ({ currentArg, previousArg }) => {
        // Refetch on page change
        return currentArg.page !== previousArg.page;
      },
      invalidatesTags: ["UnreadMessageCount"],
      transformResponse: (response, meta, arg) => response.response,
      providesTags: ["providerLocationChats"],
    }),
    sendMessage: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_chats/add_message.json`,
        method: "POST",
        data: body,
      }),
      // invalidatesTags: ["Immunization", "Charts"],
      transformResponse: (response, meta, arg) => response.response,
    }),
    speechToText: builder.mutation({
      query: (body) => ({
        url: `/speech_to_text/transcribe.json`,
        method: "POST",
        data: body,
      }),
      // invalidatesTags: ["Immunization", "Charts"],
      transformResponse: (response, meta, arg) => response.response,
    }),
    fileUpload: builder.mutation({
      query: (body) => ({
        url: `/files/temp_upload.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response,
    }),
    getProblemMeta: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_chats/problem_meta.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["ProblemMeta"],
    }),
    getPatientInfo: builder.query({
      query: (data) => {
        return {
          url: `/nursing_home_chats/patient_info.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["PatientInfo"],
    }),
    createPaDocumateThread: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_chats/status_change_create_thread.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    statusChangeChat: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_chats/status_change_chat.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response, meta, arg) =>{
        return response;
      }
    }),
    getPracticeLocations: builder.query({
      query: (data) => ({
        url: `/practices/nursing_chat_locations.json`,
        method: "GET",
        params: { ...data },
      }),
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["PracticeLocation"],
    }),
    getNursingHomeLocations: builder.query({
      query: (data) => ({
        url: `/nursing_home_chats/locations.json?`,
        method: "GET",
        params: { ...data },
      }),
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["NursingHomeLocation"],

    }),
    getPrintChatUuid: builder.query({
      query: (data) => ({
        url: `/nursing_home_chats/print.json`,
        method: "GET",
        params: { ...data },
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getProvider: builder.query({
      query: (data) => ({
        url: `/nursing_home_chats/providers.json`,
        method: "GET",
        params: { ...data },
      }),
      transformResponse: (response, meta, arg) => response.response.data?.map((provider)=> ({...provider, display: provider.user_name})),
      providesTags: ["TaggedProvider"],
    }),
    getNurse: builder.query({
      query: (data) => ({
        url: `/nursing_home_chats/nurses.json`,
        method: "GET",
        params: { ...data },
      }),
      transformResponse: (response, meta, arg) => response.response.data?.map((nurse)=> ({...nurse, display: nurse.name})),
      providesTags: ["TaggedNurse"],
    }),
    getBillingActivities: builder.query({
      query: (data) => ({
        url: `/utilities/listing/billing_activity.json`,
        method: "GET",
        params: { ...data },
      }),
      transformResponse: (response) => response.response.data,
    }),
    createCcmBilling: builder.mutation({
      query: (body) => ({
        url: `/billing/add_ccm_billing.json?`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response,
    }),
    getAllProvider: builder.query({
      query: (data) => ({
        url: `/providers.json`,
        method: "GET",
        params: { ...data },
      }),
      transformResponse: (response) => response.response.data,
    }),
    getProvidersIncludingExternal: builder.query({
      query: (data) => {
        return {
          url: `/providers/including_external.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    getExternalProviders: builder.query({
      query: (data) => {
        return {
          url: `/external_providers/lookup.json`,
          method: "GET",
          params: { ...data },
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    getPatients: builder.query({
      query: (queryParams = null) => ({
        url: "/nursing_home_chats/patients.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    uploadAttachment: builder.mutation({
      query: (body) => ({
        url: `/utilities/upload_attachment.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response,
    }),
    getNotifiedUsers: builder.query({
      query: (queryParams = null) => ({
        url: "/nursing_home_chats/fetch_to_be_notified_users.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getEncounters: builder.query({
      query: (queryParams = null) => ({
        url: "/encounters.json",
        method: "GET",
        params: queryParams,
      }),
      // transformResponse: (response, meta, arg) => response.response.data,
      transformResponse: (response, meta, arg) => {
        return {
          data: response.response.data,
          meta: response.response.meta,
        };
      },
    }),
    getEncounterPreview: builder.query({
      query: (queryParams = null) => ({
        url: "/notes/preview_section.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getPatientUpcomingAppointments: builder.query({
      query: (queryParams = null) => ({
        url: "/appointments/patient_upcoming_appointments.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getPracticeAllLocations: builder.query({
      query: (queryParams = null) => ({
        url: "/practices/location_list.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    printEncounterSummary: builder.query({
      query: (queryParams = null) => ({
        url: "/notes/print_summary.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getEncounterSettings: builder.query({
      query: (queryParams = null) => ({
        url: "/encounters/settings.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    addPatientQuestion: builder.mutation({
      query: (body) => ({
        url: "/nursing_chat_questions/update_or_create_questions.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response,
      invalidatesTags: ["ProblemQuestions"],
    }),
    deletePatientQuestion: builder.mutation({
      query: (body) => ({
        url: "/nursing_chat_questions/delete.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response,
      invalidatesTags: ["ProblemQuestions"],
    }),
    getPatientQuestions: builder.query({
      query: (queryParams = null) => ({
        url: "/nursing_chat_questions/index.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response) => response,
      providesTags: ["ProblemQuestions"],
    }),
    markProblemActive: builder.mutation({
      query: (body) => ({
        url: "/nursing_chat_questions/activate.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response,
      invalidatesTags: ["ProblemQuestions"],
    }),
    markProblemInactive: builder.mutation({
      query: (body) => ({
        url: "/nursing_chat_questions/deactivate.json",
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response,
      invalidatesTags: ["ProblemQuestions"],
    }),
    enableTwoFA  : builder.mutation({
      query: (body) => ({
        url: `/two_factor_auth/enable.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response.response.data,
    }),
    verifyTwoFACode  : builder.mutation({
      query: (body) => ({
        url: `/two_factor_auth/enable_verify_code.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response.response.data,
    }),
    resendOtpSms  : builder.mutation({
      query: (body) => ({
        url: `/two_factor_auth/resend_otp_sms.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response.response,
    }),
    disable2Fa : builder.mutation({
      query: (body) => ({
        url: `/two_factor_auth/disable.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response.response,
    }),
    generateBackUpCodes : builder.mutation({
      query: (body) => ({
        url: `/two_factor_auth/generate_new_backup_codes.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response.response.data,
    }),
    getSecurityInfo: builder.query({
      query: (queryParams = null) => ({
        url: "/nursing_home_management/get_security_info.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    markMessageAcknowledged: builder.mutation({
      query: (body) => ({
        url: `/nursing_home_chats/mark_acknowledged.json`,
        method: "POST",
        data: body,
      }),
      transformResponse: (response) => response.response,
    }),
    getNotifyUsers: builder.query({
      query: (queryParams = null) => ({
        url: "/nursing_chats_notification_schedulers/get_users_to_notify.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    getMessageUnreadCount: builder.query({
      query: (queryParams = null) => ({
        url: "/nursing_home_chats/unread_count.json",
        method: "GET",
        params: queryParams,
      }),
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["UnreadMessageCount"],
      serializeQueryArgs: ({ queryArgs }) => {
        return 'getMessageUnreadCount';
      },
    }),
    updateAttachment: builder.mutation({
      query: (body) => ({
        url: "/utilities/update_entity_document.json.json",
        method: "POST",
        data: body,
      }),
    }),
  }),
});

export const {
  useGetPatientChatsQuery,
  useGetLocationChatMessagesQuery,
  useGetRecentChatsQuery,
  useGetLocationChatsQuery,
  useSendMessageMutation,
  useSpeechToTextMutation,
  useFileUploadMutation,
  useGetProblemMetaQuery,
  useGetPatientInfoQuery,
  useCreatePaDocumateThreadMutation,
  useStatusChangeChatMutation,
  useGetPracticeLocationsQuery,
  useGetNursingHomeLocationsQuery,
  useGetPrintChatUuidQuery,
  useGetProviderQuery,
  useGetNurseQuery,
  useGetBillingActivitiesQuery,
  useCreateCcmBillingMutation,
  useGetAllProviderQuery,
  useGetProvidersIncludingExternalQuery,
  useGetExternalProvidersQuery,
  useGetPatientsQuery,
  useUploadAttachmentMutation,
  useGetNotifiedUsersQuery,
  useGetEncountersQuery,
  useGetEncounterPreviewQuery,
  useGetPracticeAllLocationsQuery,
  usePrintEncounterSummaryQuery,
  useGetEncounterSettingsQuery,
  useAddPatientQuestionMutation,
  useDeletePatientQuestionMutation,
  useGetPatientQuestionsQuery,
  useMarkProblemActiveMutation,
  useMarkProblemInactiveMutation,
  useEnableTwoFAMutation,
  useVerifyTwoFACodeMutation,
  useResendOtpSmsMutation,
  useDisable2FaMutation,
  useGenerateBackUpCodesMutation,
  useGetSecurityInfoQuery,
  useMarkMessageAcknowledgedMutation,
  useGetNotifyUsersQuery,
  useGetMessageUnreadCountQuery,
  useUpdateAttachmentMutation,
} = chatApi;
